// extracted by mini-css-extract-plugin
export var card = "_99-1";
export var container = "_99-0";